/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type { TimeseriesControllerTimeseriesV2PathParameters, TimeseriesDto } from '../models';

@Injectable({ providedIn: 'root' })
export class TimeseriesV2Service {
  private readonly http = inject(HttpClient);
  /**
   * @summary Get timeseries data for a device
   */

  timeseries<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId }: TimeseriesControllerTimeseriesV2PathParameters,
    timeseriesDto: TimeseriesDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v2/clients/${clientId}/devices/${deviceId}/timeseries`, timeseriesDto);
  }
}
